module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/braunsheitmannShop/ortho-field-config-translation.json
// module id = 1239
// module chunks = 0